import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  setProfileTenantIdR
} from "../../../scenes/Meeting/MeetingsSlice/MeetingsSlice";
import { useDispatch } from "react-redux";

export const UserProfileTypeCart = (props: any) => {
  const dispatch = useDispatch();
  const [meetinsIds, setMeetingsIds] = useState<any>(null);
  let { setTenantId } = props;
  const navigate = useNavigate();
  let { item, tenantName } = props;
  // console.log(item)
  const [imgSrc, setImgSrc] = useState<any>(null);
  const handleClickCart = () => {
    // console.log(item.tenantId)
   // sessionStorage.setItem("tenantId", item.tenantId);
    setTenantId(item.tenantId);
    // console.log(item)

    dispatch(setProfileTenantIdR(item));
  };
  const initialComponentRendred = (): void => {
    // console.log('priodsData',props.priodsData)
    // console.log(props?.priodsIds)
  };

  useEffect(() => {
    initialComponentRendred();
  }, [props.priodsIds]);

  useEffect(() => {
    // console.log(meetinsIds)
    //  console.log(meetingData)
  }, [meetinsIds]);

  useEffect(() => {
    if (item) {
      setImgSrc(item?.pictureBase64String);
    }
  }, [item]);

  return (
<Grid
  item
  sm={3}
  xs={12}
  mx={"auto"}
  md={6}
  p={2}
  onClick={() => {
    handleClickCart();
  }}
>
  <Box
    borderRadius={18}
    bgcolor={"rgba(0, 0, 0, 0.30)"}
    boxShadow={3}
    sx={{ cursor: "pointer" }}
  >
    <Box
      py={3}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        height={"150px"}
        justifyContent={"center"}
        textAlign={"center"}
        overflow={"hidden"} // جلوگیری از خروج عکس از محدوده باکس
      >
  <img
    src={imgSrc}
    alt="Card Image"
    style={{
      maxWidth: "80%", // حداکثر عرض 80% کارت
      maxHeight: "100%", // جلوگیری از بزرگ شدن بیش از حد
      objectFit: "contain", // حفظ نسبت ابعاد تصویر
      borderRadius: "10%", // گوشه‌های گرد برای زیبایی
    }}
        />
      </Box>
      <Box display={"flex"} flexDirection={"column"} textAlign={"center"} marginTop={1}>
        <Typography fontSize={"18px"} fontWeight={600} variant="caption">
          {item.tenantName}
        </Typography>
      </Box>
    </Box>
  </Box>
</Grid>

  );
};
